import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVisualBuilderBasePayload } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedVariations } from "@src/store/slices/variations";
import { mpVisualBuilderCloseCompleted } from "@src/utils/mixpanel";

export interface TrackCloseCompletedPayload {
  close_modal_choice?: "save" | "discard";
}

export const trackCloseCompleted = createAsyncThunk<
  void,
  TrackCloseCompletedPayload | void
>("experienceBuilder/tracking/closeCompleted", (payload, { getState }) => {
  const basePayload = getVisualBuilderBasePayload(getState());
  if (basePayload) {
    const mods = experienceBuilderSlice.selectors.getMods(getState());
    const variationId =
      experienceBuilderSlice.selectors.getVariationId(getState());
    const variationMods = mods.filter((m) => m.variationId === variationId);
    const device = experienceBuilderSlice.selectors.getDevice(getState());

    const variations = selectedVariations(getState());
    mpVisualBuilderCloseCompleted({
      ...basePayload,
      test_group_count: variations.length,
      close_modal_choice: payload?.close_modal_choice,
      mod_count: variationMods.length,
      builder_mode: device,
    });
  }
});
